import { Environment } from "@coxauto-ui/cxm/communications/interfaces";
import authClient from "@coxauto-ui/core-auth-get-auth-client-customer-conversation";
import { getEnvConfig } from "@coxauto-ui/core/get-env";
import { CxmEnvironmentValues } from "@coxauto-ui/cxm/interfaces";

const { BASE_URL: baseUrl, MEDIA_BFF_URL: mediaBffUrl } = getEnvConfig<
  CxmEnvironmentValues & { MEDIA_BFF_URL: string }
>("communications");

export type BaseUrlsObj = { [key in Environment]: string };

export type apiConfig = {
  baseUrls: BaseUrlsObj;
};

export function getBaseUrl(env: Environment) {
  return baseUrl;
}

export function getMediaBffBaseUrl() {
  return mediaBffUrl;
}

export const getHeader = async (version = 1) => {
  const bridgeJwt = await authClient.getAuth();

  return {
    Authorization: `Bearer ${bridgeJwt}`,
    Accept: `application/vnd.coxauto.v${version}+json`,
    "Content-Type": `application/vnd.coxauto.v${version}+json`
  };
};

export const getMediaBffHeader = async (coOrgId: string) => {
  const jwt = await authClient.getAuth();

  return {
    Authorization: `Bearer ${jwt}`,
    Accept: "application/vnd.coxauto.v1+json",
    "x-coOrgId": coOrgId
  };
};
